module.exports = __webpack_public_path__ + "img/main_2.bd1acf08.png";